import { Injectable } from '@angular/core';
import { switchMap } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { AuthStorageService, BaseSiteService, UserIdService, OCC_USER_ID_CURRENT } from "@spartacus/core";
import { Store } from "@ngrx/store";
import { AuthActions } from "@spartacus/core";

export interface SapTokenResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token?: string;
  scope?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GenAuthHelperService {

  constructor(
    private http: HttpClient,
    protected baseSiteService: BaseSiteService,
    private authStorageService: AuthStorageService,
    private userIdService: UserIdService,
    private store: Store
  ) {
  }

  loginToSSOAndSAP(ssoToken: string, salesOrgId?: string, customerNbr?: string) {
    return this.baseSiteService.getActive().pipe(
      switchMap(siteName => {
        const body = new HttpParams()
          .set('client_id', 'mobile_android_public')
          .set('grant_type', 'urn:generac:auth0')
          .set('site', siteName)
          .set('auth0Token', ssoToken)
          .set('salesOrgId', salesOrgId ?? '')
          .set('customerNbr', customerNbr ?? '');

        return this.http.post<SapTokenResponse>(
          `${environment.backend.occ.baseUrl}/authorizationserver/oauth/token`,
          body.toString(),
          {
            headers: new HttpHeaders({
              'Content-Type': 'application/x-www-form-urlencoded'
            })
          }
        );
      })
    );
  }

  storeTokenAndLogin(tokenResponse: SapTokenResponse): void {
    const now = String(Date.now());
    this.authStorageService.setToken({
      access_token: tokenResponse.access_token,
      token_type: tokenResponse.token_type || 'Bearer',
      refresh_token: tokenResponse.refresh_token,
      expires_at: String(Date.now() + tokenResponse.expires_in * 1000),
      access_token_stored_at: now,
    });
    this.userIdService.setUserId(OCC_USER_ID_CURRENT);
    this.store.dispatch(new AuthActions.Login());
  }
}
